var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("h6", [_vm._v(_vm._s(_vm.$t("Tool.TableColor")))]),
      _c("color-setting", { ref: "color" }),
      _vm.$checkPermission(["button_allowCustomPage"])
        ? [
            _c("h6", [_vm._v(_vm._s(_vm.$t("Message.CustomPageSettings")))]),
            _c(
              "div",
              { staticStyle: { padding: "20px", "text-align": "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      "background-color": "#409EFF",
                      "border-color": "#409EFF"
                    },
                    attrs: { type: "primary" },
                    on: { click: _vm.enterCustomPageSetting }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Message.EnterCustomPageSettings")) +
                        " "
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _c("h6", [_vm._v(_vm._s(_vm.$t("Tool.PartnerDisplayControl")))]),
      _c("partner-label-setting", { ref: "partner" }),
      _c("h6"),
      _c("job-copy-setting", { ref: "jobCopySetting" }),
      _c("h6"),
      _vm.showImperials
        ? _c("div", [_c("imperial-setting", { ref: "imperial" })], 1)
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }